import { ChevronLeftIcon, EnterIcon } from '@radix-ui/react-icons';
import { Button, Card, Flex, Spinner } from '@radix-ui/themes';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useMutation, useQuery } from 'react-query';
import { useSelector } from 'react-redux';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import CheckboxComponent from '../../../components/inputs/Checkbox/CheckboxComponent';
import TextFieldComponent from '../../../components/inputs/Textfield/TextfieldComponent';
import { RootState } from '../../../redux/store';
import { routes } from '../../../routes';
import { changePasswordPolicy, getPasswordPolicy } from '../../../services/user/changePasswordPolicy';
import { ChangePasswordPolicyType } from '../../../types/User';
import { ChangePasswordPolicyFormValidation } from './ChangePasswordPolicyFormValidation';

export const ChangePasswordPolicy = () => {

  const userData = useSelector((state: RootState) => state.login.userData);
  const mutation = useMutation({ mutationFn: changePasswordPolicy, mutationKey: 'changePasswordPolicy' })
 

  const defaultValues: ChangePasswordPolicyType = {
    requireDigit: false,
    requireLowercase: false,
    requireNonAlphanumeric: false,
    requireUppercase: false,
    requiredLength: 0,
    requiredUniqueChars: 0,
  };

  const navigate = useNavigate();

  const { control, handleSubmit, formState: { errors }, reset } = useForm<ChangePasswordPolicyType>({
    resolver: yupResolver(ChangePasswordPolicyFormValidation),
    defaultValues,
    mode: 'onBlur',
    reValidateMode: 'onBlur',
    shouldUseNativeValidation: false,
  });
  const { isLoading, refetch, isError, error } = useQuery(
    [],
    async () => {

      // if (studentCodeValue.trim().length < 17) return;
      try {
      const passwordPolicy =  await getPasswordPolicy();
      reset(passwordPolicy)
      return passwordPolicy;
      } catch (error) {
        console.log({error})
      }
    },
    {
      enabled: true,
      refetchOnWindowFocus: true,
      retry: true
    }
  );
  const onSubmit = handleSubmit(async (data) => {
    console.log(data)
     try {
       const result = await mutation.mutateAsync(data);
      if (result) {
        toast.success("Politicas da senha do utilizador actualizadas com sucesso!");
      }
     } catch (err: any) {
     toast.error(`${mutation.error ?? err?.message}`);
    }
  });

  const handleBack = () => {
    navigate(routes.dashboard);
  }

  return (
    <Card size='3'>

      <form onSubmit={onSubmit} noValidate>

        <Flex direction='column' gap='4'>
          <CheckboxComponent name="requireDigit" label="Exigir dígito" control={control} errors={errors} required onChange={(checked) => console.log("Checkbox está:", checked)} />
          <CheckboxComponent name="requireLowercase" label="Exigir letra minúscula" control={control} errors={errors} required onChange={(checked) => console.log("Checkbox está:", checked)} />
          <CheckboxComponent name="requireNonAlphanumeric" label="Exigir caractere especial" control={control} errors={errors} required onChange={(checked) => console.log("Checkbox está:", checked)} />
          <CheckboxComponent name="requireUppercase" label="Exigir letra maiúscula" control={control} errors={errors} required onChange={(checked) => console.log("Checkbox está:", checked)} />
          <TextFieldComponent name="requiredLength" label="Tamanho mínimo da senha" control={control} errors={errors} fieldProps={{ placeholder: 'Tamanho mínimo da senha', type: 'number' }} />
          <TextFieldComponent name="requiredUniqueChars" label="Caracteres únicos necessários" control={control} errors={errors} fieldProps={{ placeholder: 'Caracteres únicos necessários', type: 'number' }} />
          <Flex direction='row' gap='4' style={{ alignSelf: 'end' }}>
            <Button type="submit" disabled={mutation.isLoading}  >
              {mutation.isLoading ? <Spinner loading> <EnterIcon /></Spinner> : <EnterIcon />}
              Actualizar
            </Button>
          </Flex>
        </Flex>
      </form>

    </Card >
  );
};